import { FormControl, OutlinedInput, Button } from "@mui/material";
import { useState, ChangeEvent } from "react";
import { useDebounce } from "../../customHooks/useDebounce";
import { ISearchFees, TFeeSearchValue } from "../../interfaces/configuration";

const SearchFees = ({ handleGetFees }: ISearchFees) => {
  const [searchValue, setSearchValue] = useState<TFeeSearchValue>(
    {} as TFeeSearchValue
  );

  const { setSubmitting } = useDebounce(() => {
    if (searchValue.content) {
      setSearchValue({ ...searchValue, activeSearch: true });
      handleGetFees(searchValue.content);
    }
  });

  const { setSubmitting: setSubmittingClose } = useDebounce(() => {
    setSearchValue({ content: "", activeSearch: false });
    handleGetFees();
  });

  return (
    <FormControl size="small" fullWidth>
      <OutlinedInput
        placeholder="Buscar por nombre"
        className="f-s-14"
        value={searchValue.content}
        onKeyUp={(e) => e.key === "Enter" && setSubmitting(true)}
        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
          setSearchValue({ ...searchValue, content: value });
        }}
        endAdornment={
          <Button
            className="search-input-adornment"
            onClick={() =>
              searchValue.activeSearch
                ? setSubmittingClose(true)
                : setSubmitting(true)
            }
          >
            <span className="material-symbols-rounded text-muted f-s-24">
              {searchValue.activeSearch ? "close" : "search"}
            </span>
          </Button>
        }
      />
    </FormControl>
  );
};

export default SearchFees;
